import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Layout } from 'antd'
import { HeaderSection } from 'app/components/Layouts'
import { Text } from 'styles/reactnative'

const { Content } = Layout
export const AdminPriceCheckPage = () => {
	return (
		<Layout>
			<Helmet>
				<title>ADMIN DASHBOARD</title>
			</Helmet>
			<HeaderSection />
			<Content className="site-layout" style={{ padding: '10px 50px' }}>
				<Text>AdminPriceCheckPage</Text>
			</Content>
		</Layout>
	)
}
